/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;



//////////////////
// WEBPACK FOOTER
// ./~/victory-polar-axis/~/lodash/noop.js
// module id = ./node_modules/victory-polar-axis/node_modules/lodash/noop.js
// module chunks = 1